module.exports = __webpack_public_path__ + "64c589906b3ec49e23ebe25836a37b6c.ttf";